import { CountingSystem, CountingSystemConfig } from '../types';

export const COUNTING_SYSTEMS: Record<CountingSystem, CountingSystemConfig> = {
  'hi-lo': {
    name: 'Hi-Lo',
    balanced: true,
    description: 'Most popular system. Easy to learn, effective.',
    values: {
      '2': 1, '3': 1, '4': 1, '5': 1, '6': 1,
      '7': 0, '8': 0, '9': 0,
      '10': -1, 'J': -1, 'Q': -1, 'K': -1, 'A': -1
    }
  },
  'ko': {
    name: 'Knock-Out (KO)',
    balanced: false,
    description: 'Unbalanced system. No true count conversion needed.',
    values: {
      '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1,
      '8': 0, '9': 0,
      '10': -1, 'J': -1, 'Q': -1, 'K': -1, 'A': -1
    }
  },
  'hi-opt-i': {
    name: 'Hi-Opt I',
    balanced: true,
    description: 'More accurate but harder. Aces counted separately.',
    values: {
      '2': 0, '3': 1, '4': 1, '5': 1, '6': 1,
      '7': 0, '8': 0, '9': 0,
      '10': -1, 'J': -1, 'Q': -1, 'K': -1, 'A': 0
    }
  },
  'hi-opt-ii': {
    name: 'Hi-Opt II',
    balanced: true,
    description: 'Most accurate, most complex. For advanced counters.',
    values: {
      '2': 1, '3': 1, '4': 2, '5': 2, '6': 1, '7': 1,
      '8': 0, '9': 0,
      '10': -2, 'J': -2, 'Q': -2, 'K': -2, 'A': 0
    }
  },
  'omega-ii': {
    name: 'Omega II',
    balanced: true,
    description: 'Multi-level system with high accuracy.',
    values: {
      '2': 1, '3': 1, '4': 2, '5': 2, '6': 2, '7': 1,
      '8': 0, '9': -1,
      '10': -2, 'J': -2, 'Q': -2, 'K': -2, 'A': 0
    }
  }
};

export function getCardValue(rank: string, system: CountingSystem): number {
  return COUNTING_SYSTEMS[system].values[rank as keyof typeof COUNTING_SYSTEMS[typeof system]['values']] || 0;
}

export function isBalancedSystem(system: CountingSystem): boolean {
  return COUNTING_SYSTEMS[system].balanced;
}
